import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { PropertyType } from "@app/catalog";


@Component({
  selector: "property-item-row",
  standalone: false,
  templateUrl: "./property-item-row.component.html",
  styleUrl: "./property-item-row.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyItemRowComponent {
  public propertyType = input<PropertyType>();
  public name = input.required<string>();
  public value = input.required<string | number>();

  public isNumericValue = computed(() => {
    if (this.propertyType() === PropertyType.RoomContent) {
      const val = this.value();
      if (val === null || val === undefined || val === '') return false;
      const str = String(val).trim();
      // Check if string contains any digit
      return /\d/.test(str);
    }
    return false;
  });
}
